import cloudloop from "@/mixins/cloudloop";
import { v4 as uuidv4 } from "uuid";
import bytes from "bytes";

export default {
  mixins: [cloudloop],
  data() {
    return {};
  },
  methods: {
    processFiles(files) {
      return new Promise((resolve, reject) => {
        console.log(files);
        for (var file of files) {
          // Lossless only. Accept by MIME OR extension — browsers often report
          // an empty type for AIFF/FLAC. The server re-checks and rejects lossy.
          const name = (file.name || "").toLowerCase();
          const okType = /^audio\/(wav|x-wav|wave|aiff|x-aiff|aifc|flac|x-flac)$/.test(
            file.type,
          );
          const okExt = /\.(wav|aif|aiff|aifc|flac)$/.test(name);
          if (!okType && !okExt)
            return reject(
              `Unsupported file "${file.name || file.type}". Use lossless audio (WAV, AIFF, or FLAC).`,
            );
          // test for file size
          if (file.size > bytes("4 GB")) {
            return reject(
              `File too big. Your file(s) should be smaller than ${process.env.MAX_FILE_SIZE}.`,
            );
          }

          const targetSession =
            this.sessionName || this.$store.state.selectedSession?.name;

          // Prevent duplicate enqueue of the same active file (e.g. event bubbling or accidental multi-drop)
          const isDuplicateInFlight = (this.$store.state.files || []).some(
            (existing) => {
              const sameSession =
                !existing.sessionName || existing.sessionName === targetSession;
              const sameFile =
                existing.file === file ||
                (existing.name === file.name &&
                  existing.size === file.size &&
                  (!file.lastModified ||
                    existing.file?.lastModified === file.lastModified));
              const inFlight = [
                "added",
                "processing",
                "processed",
                "uploading",
              ].includes(existing.status);
              return sameSession && sameFile && inFlight;
            },
          );

          if (isDuplicateInFlight) {
            console.warn(
              `File "${file.name}" is already queued or uploading. Ignoring duplicate.`,
            );
            continue;
          }

          // add file to store
          let fileobj = {
            file,
            uuid: uuidv4(),
            name: file.name,
            size: file.size,
            sessionName: targetSession,
            status: "added",
            fileUrl: URL.createObjectURL(file),
            progress: 0.0,
          };
          this.$store.commit("addFile", fileobj);
          this.parseFiles();
        }
        resolve();
      });
    },

    retryFile(uuid) {
      const file = this.$store.state.files.find((f) => f.uuid === uuid);
      if (!file) return;
      this.$store.commit("updateFile", {
        uuid: file.uuid,
        newFile: {
          ...file,
          status: "added",
          progress: 0.0,
          error: null,
        },
      });
      this.parseFiles();
    },

    parseFiles() {
      // only parse one file at a time
      if (this.$store.state.files.find((file) => file.status === "processing"))
        return;

      const file = this.$store.state.files.find(
        (file) => file.status === "added",
      );
      if (!file) return;
      console.log(`Found file ${file.uuid} for processing.`);
      file.status = "processed";
      file.metadata = {};
      console.log(`Got metadata for file ${file.uuid} - ${file.metadata}`);
      this.$store.commit("updateFile", { uuid: file.uuid, newFile: file });
      // run again untl all added files are parsed
      this.parseFiles();
      console.log("before upload.");
      this.uploadFiles();
    },

    uploadFiles() {
      // only parse one file at a time
      if (this.$store.state.files.find((file) => file.status === "uploading"))
        return;

      const file = this.$store.state.files.find(
        (file) => file.status === "processed",
      );

      if (!file) return;

      const username = this.$store.state.loggedInUser?.username;
      const sessionName =
        file.sessionName ||
        this.sessionName ||
        this.$store.state.selectedSession?.name;

      if (!username || !sessionName) {
        console.error("Missing username or session name for upload", {
          username,
          sessionName,
        });
        this.$store.commit("updateFile", {
          uuid: file.uuid,
          newFile: {
            ...file,
            status: "error",
            error: "Session or user information unavailable",
          },
        });
        return;
      }

      this.$store.commit("updateFileStatus", { uuid: file.uuid, status: "uploading" });

      this.uploadAudioWithProgress(
        file.file,
        username,
        sessionName,
        file.uuid,
        this,
      )
        .then(() => {
          this.$store.commit("updateFileStatus", { uuid: file.uuid, status: "complete" });
          if (typeof this.loadSession === "function" && sessionName) {
            this.loadSession(sessionName);
          }
        })
        .catch((error) => {
          console.error(`Upload failed for ${file.uuid}:`, error);
          this.$store.commit("updateFile", {
            uuid: file.uuid,
            newFile: { ...file, status: "error", error: error.message || String(error) },
          });
        })
        .finally(() => this.uploadFiles());
    },
  },
};
